/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_onboarding_invite_team_skip = /** @type {(inputs: {}) => string} */ () => {
	return `Omitir por ahora`
};

const en_onboarding_invite_team_skip = /** @type {(inputs: {}) => string} */ () => {
	return `Skip for now`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const onboarding_invite_team_skip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.onboarding_invite_team_skip(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("onboarding_invite_team_skip", locale)
	if (locale === "es") return es_onboarding_invite_team_skip(inputs)
	return en_onboarding_invite_team_skip(inputs)
};
export { onboarding_invite_team_skip as "onboarding.invite_team.skip" }